// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"theme_sectionTitle__k_Z27","page":"style_page__DYaOZ theme_page__1oxFh","mainTitle":"style_mainTitle__23Ypi theme_sectionTitle__k_Z27"};